import React from 'react';
import styles from './UIGamePortraitTop.module.scss';
import { UIGameHelpUserSettingsButtonContainer } from '../UIGameHelpButtons/UIGameHelpButtons.tsx';
import { UIGameEndReturnToStats } from '../UIGameEnd/UIGameEndReturnToStats/UIGameEndReturnToStats.tsx';
import { useGameStore } from '../../store/GameStoreContext.ts';
import clsx from 'clsx';
import { useIsGameEnded } from '../../store/selectors/useIsGameEnded.ts';
import { UIGameBankPortrait } from '../UIGameBankPortrait/UIGameBankPortrait.tsx';
import { useBankCardStackSizes } from '../UIGameBank/useBankCardStackSizes.ts';
import { useBankCardState } from '../UIGameBank/useBankCardState.ts';
import { UIGameHelpInformationButton } from '../UIGameHelpButtons/UIGameHelpInformationButton/index.ts';
import { UIGamePlayerInfoToggle } from '../UIGamePlayerInfoToggle/UIGamePlayerInfoToggle.tsx';
import IconUsedDevs from '@static/images/icon_used_devs.svg';
import IconCK from '@static/images/player_info_toggle_ck_icon.svg';
import { UIGamePlayerInfoToggleContentPieces } from '../UIGamePlayerInfoToggle/UIGamePlayerInfoToggleContentPieces.tsx';
import { useMyPerspectiveColor } from '../../store/selectors/useMyPerspectiveColor.ts';
import { ModeSettingEnum } from '@colonist/types';
export const UIGamePortraitTop = ({ isPlayerInfoSectionUsedDevsActive, setIsPlayerInfoSectionUsedDevsActive, isPlayerInfoSectionCKActive, setIsPlayerInfoSectionCKActive, isPlayerInfoSectionPiecesActive, setIsPlayerInfoSectionPiecesActive, initialCanResign, className })=>{
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P;
    const isGameEnded = useIsGameEnded();
    const bankCardState = useBankCardState();
    const bankCardStackSizes = useBankCardStackSizes();
    const hideBankCards = useGameStore((state)=>state.gameState.bankState.hideBankCards);
    const progressCards = useGameStore((state)=>{
        var _state_gameState_mechanicProgressCardsState;
        return (_state_gameState_mechanicProgressCardsState = state.gameState.mechanicProgressCardsState) === null || _state_gameState_mechanicProgressCardsState === void 0 ? void 0 : _state_gameState_mechanicProgressCardsState.bankProgressCards;
    });
    const isMechanicIslandExplorationActive = useGameStore((state)=>state.gameState.mechanicIslandExplorationState) !== undefined;
    const victoryPointsToWin = useGameStore((state)=>state.gameSettings.victoryPointsToWin);
    const myPerspectiveColor = useMyPerspectiveColor();
    const isMechanicDevelopmentCardsActive = useGameStore((state)=>state.gameState.mechanicDevelopmentCardsState) !== undefined;
    const isMechanicCityImprovementsActive = useGameStore((state)=>state.gameState.mechanicCityImprovementsState) !== undefined;
    const sendInGameInfoWindowViewedAnalytics = useGameStore((state)=>state.gameAnalytics.sendInGameInfoWindowViewedAnalytics);
    const sendInGameInfoWindowClosedAnalytics = useGameStore((state)=>state.gameAnalytics.sendInGameInfoWindowClosedAnalytics);
    const sendInGameInfoWindowTabChangedAnalytics = useGameStore((state)=>state.gameAnalytics.sendInGameInfoWindowTabChangedAnalytics);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.topContainerPortrait, className)
    }, !isGameEnded && /*#__PURE__*/ React.createElement("div", {
        className: styles.helpButtonsContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.settingsButtonContainer
    }, /*#__PURE__*/ React.createElement(UIGameHelpUserSettingsButtonContainer, {
        className: styles.settingsButton,
        initialCanResign: initialCanResign,
        isRulesOptionVisible: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.infoButtonContainer
    }, /*#__PURE__*/ React.createElement(UIGameHelpInformationButton, {
        isDismissibleByOutsideClick: true,
        className: styles.infoButton,
        gameMode: modeSetting,
        isMechanicIslandExplorationActive: isMechanicIslandExplorationActive,
        playerColor: myPerspectiveColor,
        victoryPointsToWin: victoryPointsToWin,
        onInfoWindowViewed: sendInGameInfoWindowViewedAnalytics,
        onInfoWindowClosed: sendInGameInfoWindowClosedAnalytics,
        onInfoWindowTabChanged: sendInGameInfoWindowTabChangedAnalytics
    }))), isGameEnded && /*#__PURE__*/ React.createElement("div", {
        className: styles.gameEndReturnToStatsContainer
    }, /*#__PURE__*/ React.createElement(UIGameEndReturnToStats, {
        text: "strings:game.endGame.cornerButton.openStatsMobile",
        className: styles.gameEndReturnToStatsButton
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameBankContainer
    }, /*#__PURE__*/ React.createElement(UIGameBankPortrait, {
        cardState: bankCardState,
        cardStackSizes: bankCardStackSizes,
        hideBankCards: hideBankCards,
        modeSetting: modeSetting,
        progressCards: progressCards
    })), !isBeginnerMode && /*#__PURE__*/ React.createElement("div", {
        className: styles.gamePlayerInfoToggleContainer
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoToggle, {
        isActive: isPlayerInfoSectionPiecesActive,
        setIsActive: setIsPlayerInfoSectionPiecesActive
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoToggleContentPieces, {
        playerColor: myPerspectiveColor
    })), isMechanicDevelopmentCardsActive && /*#__PURE__*/ React.createElement(UIGamePlayerInfoToggle, {
        isActive: isPlayerInfoSectionUsedDevsActive,
        setIsActive: setIsPlayerInfoSectionUsedDevsActive
    }, /*#__PURE__*/ React.createElement("img", {
        src: IconUsedDevs,
        className: styles.gamePlayerInfoToggleIcon
    })), isMechanicCityImprovementsActive && /*#__PURE__*/ React.createElement(UIGamePlayerInfoToggle, {
        isActive: isPlayerInfoSectionCKActive,
        setIsActive: setIsPlayerInfoSectionCKActive
    }, /*#__PURE__*/ React.createElement("img", {
        src: IconCK,
        className: styles.gamePlayerInfoToggleIcon
    }))));
};
